export function isReauthableError(error) {
  return error.status === 400 || error.status === 401;
}
